<div class="create-payment-notice-page">
  <div class="header">
    <h1>{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.TITLE' | translate }}</h1>
  </div>

  <app-information-block [text]="'AMORTIZATION_PLAN.PAYMENT_NOTICE.PAGE_DESCRIPTION' | translate"></app-information-block>

  <form [formGroup]="form" (ngSubmit)="submit()" class="payment-notice-form astral-content-width astral-stack-l">
    <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <astral-remote-multi-select
          [control]="form.controls['companyIds']"
          [service]="companyService"
        ></astral-remote-multi-select>
        <app-month-year-select [control]="form.controls['dueFrom']" [itemsSource]="periodSelection"></app-month-year-select>
        <app-month-year-select [control]="form.controls['dueTo']" [itemsSource]="periodSelection"></app-month-year-select>
      </astral-layout-group>
    </section>

    @if (hasInvalidPeriod) {
      <div class="invoice-excluded-message">
        {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.INVALID_PERIOD' | translate }}
      </div>
    }

    <div class="astral-form-actions">
      <astral-button
        variant="secondary"
        type="button"
        (click)="previewPaymentNotices()"
        [disabled]="!canPreview"
        labelKey="AMORTIZATION_PLAN.PAYMENT_NOTICE.PREVIEW_ACTION"
      ></astral-button>
    </div>

    @if (isLoading) {
      <div class="loading-text">{{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.LOADING' | translate }}</div>
    }

    @if (previewLoaded) {
      <div class="section">
        <div class="section-title">
          {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.PREVIEW_RESULT' | translate }} ({{ preview?.manualNoticeInstallments?.length || 0 }})
        </div>
        @if (!(preview?.manualNoticeInstallments?.length)) {
          <div class="empty-state">
            {{ 'AMORTIZATION_PLAN.PAYMENT_NOTICE.NO_PAYMENT_NOTICES' | translate }}
          </div>
        }
        @if (preview?.manualNoticeInstallments?.length) {
          <div class="invoice-table">
            <div class="invoice-row invoice-row-header preview-grid">
              <span>{{ 'COMMON.CONTACT' | translate }}</span>
              <span>{{ 'COMMON.COMPANY' | translate }}</span>
              <span>{{ 'AMORTIZATION_PLAN.CREATE.INSTALLMENT_DUE_DATE' | translate }}</span>
              <span>{{ 'COMMON.AMOUNT' | translate }}</span>
              <span>{{ 'COMMON.DESCRIPTION' | translate }}</span>
            </div>
            @for (item of preview?.manualNoticeInstallments; track item) {
              <div class="invoice-row preview-grid">
                <span>{{ item.debtorContactName }}</span>
                <span>{{ item.companyName }}</span>
                <span>{{ item.dueDate?.toLocaleDateString() }}</span>
                <span>{{ item.amount?.toString() }}</span>
                <span>{{ item.description }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" [disabled]="!canCreate" labelKey="CREATE_BTN"></astral-button>
      <astral-button variant="secondary" type="button" (click)="cancel()" [disabled]="isSaving" labelKey="CANCEL_BTN"></astral-button>
    </div>
  </form>
</div>
